import { getCreationInput, isBusinessId, validateCreationEntry } from './harness-creation';

const entryKeys = ['seedPlanId', 'hotPotId'];
const creationKeys = [...entryKeys, 'threadId', 'idea', 'entry', 'recordId', 'title', 'view'];
export const getCreationQueryValue = (value) => (Array.isArray(value) ? value.at(-1) : value);

export const getPendingCreationEntry = (query) => {
  if ([...entryKeys, 'idea'].some((key) => Object.hasOwn(query, key))) {
    throw new Error('缺少创作记录，请返回后重新开始');
  }
  if (!['entry', 'recordId'].some((key) => Object.hasOwn(query, key))) return undefined;
  const entry = getCreationQueryValue(query.entry);
  if (!['seedPlan', 'hotPot'].includes(entry)) throw new Error('创作来源无效，请重新选择');
  return validateCreationEntry({ [`${entry}Id`]: getCreationQueryValue(query.recordId) });
};

export const clearCreationQuery = (query) =>
  Object.fromEntries(Object.entries(query).filter(([key]) => !creationKeys.includes(key)));

export const getCreationRecordQuery = (record, idea) => {
  if (!isBusinessId(record?.id) || !['legacy', 'harness'].includes(record.mode)) {
    throw new Error('创作记录无效');
  }
  const entry = record.entry == null ? {} : validateCreationEntry(record.entry);
  return {
    mode: record.mode,
    threadId: record.id,
    ...(idea === undefined ? entry : getCreationInput({ idea })),
  };
};

export const resolveCreationRecord = (query, record) => {
  const canonical = getCreationRecordQuery(record);
  if (getCreationQueryValue(query.threadId) !== record.id) {
    throw new Error('创作记录不一致');
  }
  const supplied = Object.fromEntries(
    entryKeys.filter((key) => Object.hasOwn(query, key)).map((key) => [key, query[key]]),
  );
  if (Object.hasOwn(query, 'idea')) supplied.idea = query.idea;
  let idea;
  if (Object.keys(supplied).length) {
    const normalized = getCreationInput(supplied);
    ({ idea } = normalized);
    const entry = Object.entries(normalized).filter(([key]) => key !== 'idea');
    if (entry.some(([key, value]) => canonical[key] !== value)) {
      throw new Error('创作入口与记录不一致');
    }
  }
  if (Object.hasOwn(query, 'entry') || Object.hasOwn(query, 'recordId')) {
    const entry = getCreationQueryValue(query.entry);
    const recordId = getCreationQueryValue(query.recordId);
    if (
      !['seedPlan', 'hotPot'].includes(entry) ||
      !isBusinessId(recordId) ||
      canonical[`${entry}Id`] !== recordId
    ) {
      throw new Error('创作入口与记录不一致');
    }
  }
  // A later source binding must not change the active Harness URL or replay its idea.
  if (
    idea !== undefined ||
    (record.mode === 'harness' && !Object.keys(supplied).length && !Object.hasOwn(query, 'entry'))
  ) {
    entryKeys.forEach((key) => delete canonical[key]);
  }
  const resolved = {
    ...clearCreationQuery(query),
    ...canonical,
    ...(idea === undefined ? {} : { idea }),
  };
  if (record.mode === 'legacy' && !Object.hasOwn(query, 'mode')) delete resolved.mode;
  return resolved;
};
